import Modal from "../../../../../commons/Modal/Modal";
import { DashboardProspectsDIRAssignModalProps } from "./DashboardProspectsDIRAssignModal.types";
import DashboardProspectsDIRAssignTable from "./DashboardProspectsDIRAssignTable/DashboardProspectsDIRAssignTable";

export default ({ ...props }: DashboardProspectsDIRAssignModalProps) => {
  
  return (
    <Modal {...props} closeOnClickOutside>
      <h3>Assigner à un autre commercial</h3>
      <DashboardProspectsDIRAssignTable />
    </Modal>
  )
}